import React, { Component } from 'react';
import { Link } from 'react-router';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';

class InfoButton extends Component {

  render() {
    return (
        <div>
          <Link to={this.props.link} className="content-margin-20 info-button">{this.props.text}</Link>
        </div>
    );
  }
}

export default InfoButton;



// WEBPACK FOOTER //
// ../components/InfoButton.js